import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Acl } from 'modules/common/components/Acl';
import Alert from 'react-s-alert';
import moment from 'moment';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import * as actions from '../actions';
import * as c from '../constant';

const Profession = ({
  getList,
  list,
  isLoading,
  pager,
  // permissions,
  getReportAccess,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState({
    subject: '',
  });

  const [token, setToken] = useState('');

  const [file, setFile] = useState({});

  const fileHandler = e => {
    setFile(e.target.files[0]);
  };

  const handleChangePageTab1 = page => {
    getList({ ...formData, page });
  };

  useEffect(() => {
    getList({ subject: 'PROFESSION' });

    setFormData({
      subject: 'PROFESSION',
    });
  }, []);

  const postFormData = url => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', e =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = evt => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });

  const onUploadFile = async e => {
    e.preventDefault();

    const data = new FormData();

    try {
      data.append('file', file);
      data.append('subject', _.get(formData, 'subject'));
      const res = await postFormData(
        `${process.env.REACT_APP_WS}/api/v1/administrators/settings/csv_imports`
      )(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        getList({ subject: 'PROFESSION' });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.errors.subject.0'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  const authProfile = getJson('profile') || {};

  const handleDownload = id => e => {
    e.preventDefault();

    const reportAccessArgs = {
      path: `api/v1/administrators/settings/download_failed_rows/${id}`,
      query: {
        email: _.get(authProfile, 'email'),
        output: 'D',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);
  }, []);

  return (
    <div className="mt-4">
      <div className="d-flex mt-2 px-2">
        <div className="ml-auto row-nav">
          <div className="float-left">
            <div className="form-group">
              {isLoading && (
                <button
                  disabled
                  type="button"
                  className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                >
                  <i className="fa fa-spin fa-spinner" />
                </button>
              )}
            </div>
          </div>
          <div className="float-right">
            <div className="form-group">
              {!isLoading && (
                <input
                  type="file"
                  className="btn btn-link input-upload"
                  onChange={fileHandler}
                />
              )}
            </div>
          </div>
          <div className="flow-right">
            <div className="form-group">
              <button
                type="button"
                onClick={onUploadFile}
                className="ml-2 btn btn-link button-upload"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {isLoading ? (
            <div
              className="loading d-flex text-center justify-content-center align-items-center"
              style={{ height: '500px' }}
            >
              <div className="spinner text-center ">
                <span className="fas fa-5x fa-spin fa-spinner" />
              </div>
            </div>
          ) : (
            <table className="table table-striped table-sm table-bordered table-hover">
              <thead className="table-header">
                <tr>
                  <th>SUBJECT</th>
                  <th>DATE UPLOADED</th>
                  <th>FILE NAME</th>
                  <th>FAILED ROWS</th>
                  <th>SUCCESS ROWS</th>
                  <th>TOTAL ROWS</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody className="table-details">
                {list.map(item => {
                  return (
                    <tr key={_.get(item, 'id')}>
                      <td>{_.get(item, 'attributes.subject') || '---'}</td>
                      <td>
                        {_.get(item, 'attributes.date_human')
                          ? moment(
                              `${_.get(item, 'attributes.date_human')}`
                            ).format('MMM DD, YYYY')
                          : '---'}
                      </td>
                      <td>
                        {_.get(item, 'attributes.file_name') || '---'}
                      </td>
                      <td>
                        {_.get(item, 'attributes.failed_rows') || '---'}
                      </td>
                      <td>
                        {_.get(item, 'attributes.success_rows') || '---'}
                      </td>
                      <td>
                        {_.get(item, 'attributes.total_rows') || '---'}
                      </td>
                      <td>{_.get(item, 'attributes.status') || '---'}</td>
                      <td>
                        {_.get(item, 'attributes.failed_rows') > 0 ? (
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                            onClick={handleDownload(item.id)}
                          >
                            <i className="fas fa-print" />
                          </button>
                        ) : (
                          'Completed'
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <div className="list-pagination">
            {pager.total_pages > 1 ? (
              <div className="d-flex justify-content-center text-center align-item-center">
                <Pagination data={pager} onChange={handleChangePageTab1} />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Profession.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  // permissions: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  // permissions: getJson('permissions'),
  list: _.get(api, `${c.LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Profession);
